import { createSlice } from '@reduxjs/toolkit';

import { requestProductReviews } from 'src/redux/reviews/thunks';

// Action type strings to avoid circular dependency with submitPersonalisationForm
const SUBMIT_PERSONALISATION_FORM_PENDING = 'personalisation/submitPersonalisationForm/pending';
const SUBMIT_PERSONALISATION_FORM_FULFILLED = 'personalisation/submitPersonalisationForm/fulfilled';
const SUBMIT_PERSONALISATION_FORM_REJECTED = 'personalisation/submitPersonalisationForm/rejected';

export interface AccessibilityState {
  statusMessage: string;
}

export const initialState: AccessibilityState = {
  statusMessage: '',
};

export const { actions, reducer } = createSlice({
  name: 'accessibility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestProductReviews.pending, (state, { meta }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = 'Loading reviews';
        }
      })
      .addCase(requestProductReviews.fulfilled, (state, { meta, payload }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = `Page ${payload.pagination.currentPage} of reviews loaded`;
        }
      })
      .addCase(requestProductReviews.rejected, (state, { meta }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = 'There was a problem loading reviews';
        }
      })
      .addMatcher(
        (action) => action.type === SUBMIT_PERSONALISATION_FORM_PENDING,
        (state) => {
          state.statusMessage = 'Updating basket';
        },
      )
      .addMatcher(
        (action) => action.type === SUBMIT_PERSONALISATION_FORM_FULFILLED,
        (state) => {
          state.statusMessage = 'Basket has been updated';
        },
      )
      .addMatcher(
        (action) => action.type === SUBMIT_PERSONALISATION_FORM_REJECTED,
        (state) => {
          state.statusMessage = 'There was a problem updating the basket';
        },
      );
  },
});
